<template>
  <div class="post-container" @mouseover="info=true" @mouseout="info=false" :style="{cursor:cursor}">
    <transition name="fade">
      <div v-show="isLoaded">
        <img ref="image" src="/static/images/instagram_placeholder.jpg" @load="isLoaded=true" @error="error()"/>
      </div>
    </transition>
    <div>
      <transition name="fade">
        <div v-if="info && !loadError" class="overlay-container" @click="showDetail()">
          <div class="wh100 overlay" layout="column center-center">
            <img v-if="hasUserPic" class="profile-pic" :src="postData.user.profilePicUrl" @error="hasUserPic=false"/>
            <div class="profile-name">@{{postData.user.userName}}</div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import BackendProxy from '@/BackendProxy';

  export default {
    name: "instagram-post",
    props: ['postData', 'placeholder'],
    data() {
      return {
        info: false,
        loadError: false,
        cursor: 'pointer',
        isLoaded: false,
        hasUserPic: true
      }
    },
    mounted() {
      this.loadImage();
    },
    methods: {
      showDetail() {
        if (!this.loadError) {
          window.open(`https://www.instagram.com/p/${this.$props.postData.shortcode}/`, '_blank');
        }
      },
      loadImage() {
        if (this.postData) {
          this.$refs.image.src = this.postData.thumbnails[3].src;
          this.temp =  this.$refs.image.src;

          return;
        } else {
          this.error();
        }

      },
      userPicError() {

      },
      error() {
        if (this.loadError) {
          this.$refs.image.src = '/static/images/instagram_placeholder.jpg';
        } else {
          this.$refs.image.src = this.placeholder;
        }
        this.loadError = true;
        this.cursor = 'auto';
      }
    }
  }
</script>

<style lang="scss" scoped>
  $pad: 0.2rem;
  .post-container {
    padding: 0 $pad 0 $pad;
    position: relative;

  }

  img {
    width: 100%;
  }

  .overlay-container {
    position: absolute;
    top: 0;
    left: $pad;
    bottom: 2*$pad;
    right: $pad;
    background-color: rgba(0, 159, 227, 0.65);
    overflow: hidden;
  }

  .profile-pic {
    width: 35%;
    border-radius: 50%;
    margin-bottom: 0.5rem;
  }

  .profile-name {
    font-weight: 200;
    font-size: 1.2vw;

    @media screen and (max-width: 640px) {
      font-size: 5.5vw;
    }

    @media screen and (min-width: 1000px) {
      font-size: 15px;
    }
  }

  .overlay {
  }

  fade-enter-active, .fade-leave-active {
    transition: opacity .2s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }


</style>



// WEBPACK FOOTER //
// src/components/blocks/InstagramPost.vue